"use strict";

/* https://github.com/matthewhudson/current-device */
import Viewports from '../fsUtils/Viewports.js'

class FsBeacon {
    EpgTracking(props) {
        return new EpgTracking(props);
    }

    DoubleClickFloodlightTracking() {
        return new DoubleClickFloodlightTracking({});
    }
}

/*
*   Note: props will be converted to escaped query string.
*   USAGE EXAMPLE:
*        let props = {
            postType: this.props.postType,
            content: this.props.state
        };
        FsBeacon.EpgTracking(props).send();
* */

class BaseTracking {
    constructor(props) {
        this.props = props || {};
    }

    send(url, props) {
        if (props) {
            let queryString = jsonToQueryString(props);
            url += "?" + queryString;
        }
        goFetch(url);
    }
}

class EpgTracking extends BaseTracking {
    constructor(props) {
        super(props);
        this.props.url = window.location.href;
        this.props.deviceType = (new Viewports()).isMobile ? 'Mobile' : 'Desktop';
        this.props.campaign = "fsgo_epg";
        this.url = "/conv-epg";
    }

    send() {
        super.send(this.url, this.props);
    }
}

class DoubleClickFloodlightTracking extends BaseTracking {
    /*
        Start of DoubleClick Floodlight Tag: Please do not remove
        Activity name of this tag: FoxSports_Install-Open_Counter
        URL of the webpage where the tag is expected to be placed: https://www.foxsports.com/
        This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
        Creation Date: 05/08/2018
    */
    constructor(props) {
        super(props);

        let axel = Math.random() + '';
        let a = axel * 10000000000000;
        this.url = 'https://5805365.fls.doubleclick.net/activityi;src=5805365;type=alluniqu;cat=foxsp0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?';
    }

    send() {
        super.send(this.url);
    }
}

function jsonToQueryString(json) {
    return Object.keys(json).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    }).join('&');
}

function goFetch(url) {
    fetch(url, {
        mode: 'no-cors'
    }).then(function (response) { /* intentionally left blank for future implementation. */ });
}

export default FsBeacon;



// WEBPACK FOOTER //
// ./assets/components/fs-beacon/FsBeacon.js